import ConnectionAlert from '@/components/Common/ConnectionAlert/ConnectionAlert';
import ImpressionDivWrapper from '@/components/Common/ImpressionDivWrapper';
import ToTopButton from '@/components/Common/ToTopButton/ToTopButton';
import LeisureListItem from '@/components/Leisure/Common/ListItem/LeisureListItem';
import { EN_PLACELIST_TYPE } from '@/models/Search/policies/ISearchListPolicy';
import { Kinesis } from '@/services/TrackerService';
import { LeisureCrossSellListStoreCtx } from '@/stores/LeisureCrossSellListStore';
import { hasNoItems } from '@/utils';
import { getListName } from '@/utils/domain/region';
import { useScrollStore } from '@/utils/hooks';
import { observer } from 'mobx-react-lite';
import React, { useContext, useRef } from 'react';

import styles from './LeisureCrossSellListBody.module.scss';

const LeisureCrossSellListBody: React.FC = () => {
  const store = useContext(LeisureCrossSellListStoreCtx);
  const elRef = useRef<HTMLElement>(null);

  useScrollStore({ elRef, callback: store.onLoadMore });

  if (store.isError) {
    return (
      <div className={styles.emptyContainer}>
        <ConnectionAlert className={styles.failOverContainer} onRetry={store.onRetry} />
      </div>
    );
  }

  if (hasNoItems(store.list)) {
    return (
      <div className={styles.emptyContainer}>
        <div className={styles.emptyText}>이 주변 놀거리가 없습니다</div>
        <div className={styles.emptySubText}>뒤로 이동해 다른 상품을 둘러보세요</div>
      </div>
    );
  }

  const list = store.list.map((item, idx) => {
    if (!item) {
      return;
    }

    // 핫딜 뱃지 미노출
    if (item.modifiers.hotDealLv1) {
      item.modifiers.hotDealLv1 = null;
    }

    const basicLogData = {
      listName: getListName(EN_PLACELIST_TYPE[store.placeType.toUpperCase()]),
      widgetTitle: store.title,
    };

    const logData = {
      pageName: 'LeisureRecommendList',
      objectsWith: [
        {
          leisureTicketNo: item.no,
          position: idx + 1,
        },
      ],
      objectType: 'leisureTicketNo',
      ...basicLogData,
    };

    const trackClick = (): void => {
      Kinesis.click('LeisureRecommendList', {
        object: String(item.no),
        objectType: 'leisureTicketNo',
        ...basicLogData,
        position: idx + 1,
      });
    };

    return (
      <ImpressionDivWrapper key={idx} logData={{ ...logData }}>
        <LeisureListItem item={item} onClick={trackClick} />
      </ImpressionDivWrapper>
    );
  });

  return (
    <section className={styles.container} ref={elRef}>
      <div className={styles.wrap}>{list}</div>
      <ToTopButton />
    </section>
  );
};

export default observer(LeisureCrossSellListBody);
